import { render, staticRenderFns } from "./SubHeadingFormatter.vue?vue&type=template&id=4601007a&scoped=true&"
import script from "./SubHeadingFormatter.vue?vue&type=script&lang=js&"
export * from "./SubHeadingFormatter.vue?vue&type=script&lang=js&"
import style0 from "./SubHeadingFormatter.vue?vue&type=style&index=0&id=4601007a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4601007a",
  null
  
)

export default component.exports